module.exports = __webpack_public_path__ + "static/media/dem_lia_per.52142f04.png";